import { ACCT_TABS } from '../pages/Accounting';
import { DISPATCH_TABS } from '../pages/Dispatch';
import { MASTER_TABS } from '../pages/MasterData';
import { PROFIT_TABS } from '../pages/Profit';
import { SETTLE_TABS } from '../pages/Settle';

/**
 * 개선요청 「어느 화면인가요」 고르기 목록(2026-10-19 way 「노선도 없고 명칭도 다른 것이 있다 · 하위 메뉴도」).
 *
 * 이름은 **상단 메뉴·화면 탭 이름 그대로**(App.tsx NAV · 각 화면 탭 목록) — 따로 적어 두면 메뉴가 바뀔 때 또 갈린다.
 * 하위 메뉴는 「메뉴 › 하위」로 저장한다(화면 탭 이름 `접수·배차 › 노선` 과 같은 모양 · DB 칸 40자).
 * 하위는 그 화면의 탭 목록을 그대로 가져온다(#423 — 손으로 옮겨 적은 목록은 새 탭·새 메뉴가 생겨도 안 따라왔다).
 * 🔴 상단 메뉴를 App.tsx NAV 에 더하면 여기에도 한 줄 더한다.
 */
export const SCREEN_MENUS: { menu: string; subs: string[] }[] = [
  { menu: '대시보드', subs: [] },
  { menu: '기준정보', subs: MASTER_TABS.map(([, l]) => l) },
  { menu: '편성 변경', subs: [] },
  { menu: '접수·배차', subs: DISPATCH_TABS.map(([, l]) => l) },
  { menu: '정산', subs: SETTLE_TABS.map(([, l]) => l) },
  { menu: '마감 후 수정', subs: [] },
  { menu: '재무추가', subs: [] },
  { menu: '월정기', subs: ['월정산', '정기항목'] },
  { menu: '영업정산', subs: [] },
  { menu: '할부금', subs: [] },
  { menu: '회계', subs: ACCT_TABS.map(([, l]) => l) },
  { menu: '공지사항', subs: [] },
  { menu: '개선요청', subs: [] },
  { menu: '사용 설명서', subs: [] },
  { menu: '세금계산서 발행현황', subs: [] },
  { menu: '경영 분석', subs: PROFIT_TABS.map(([, l]) => l) },
  { menu: '사용자', subs: [] },
  { menu: '기사앱', subs: [] },
  { menu: '기타', subs: [] },
];

export const subMenu = (menu: string, sub: string) => `${menu} › ${sub}`;

/** 거르기 목록(메뉴 하나 = 그 하위까지 · 서버 listImprovements 가 「메뉴 ›」 로 시작하는 것까지 센다). */
export const TOP_MENUS = SCREEN_MENUS.map((m) => m.menu);

/** 예전 이름으로 저장된 글(「배차」)도 지금 이름으로 읽히게 — 고르기 칸이 비지 않게 그 값을 한 줄 더 보여 준다. */
export function MenuOptions({ current }: { current?: string }) {
  const known = current && SCREEN_MENUS.some((m) => m.menu === current || m.subs.some((s) => subMenu(m.menu, s) === current));
  return (
    <>
      {current && !known && <option value={current}>{current} (예전 이름)</option>}
      {SCREEN_MENUS.map((m) =>
        m.subs.length === 0 ? (
          <option key={m.menu} value={m.menu}>{m.menu}</option>
        ) : (
          <optgroup key={m.menu} label={m.menu}>
            <option value={m.menu}>{m.menu} (전체)</option>
            {m.subs.map((s) => (
              <option key={s} value={subMenu(m.menu, s)}>{subMenu(m.menu, s)}</option>
            ))}
          </optgroup>
        ),
      )}
    </>
  );
}
